module.exports = __webpack_public_path__ + "img/FR18715.7654321b.png";